import type { Move } from '../../../schemas/move';

/**
 * Archetipi del Monaco (manuale V1, rr. 4461-4470).
 *
 * 5 mosse di tipo `class_special`. Pattern razza-tematico standard.
 * Tutte le mosse sono effetti continuativi o trigger su mosse esistenti
 * del Monaco / mosse base / sistema multiclasse.
 *
 * **Archetipo Umano**: l'effetto «scegli da Druido o Sciamano quando prendi
 * *La Via dell'Eremita* o *La Strada dell'Eremita*» è una regola **runtime
 * sullo stato di scelta multiclasse del PG** (FI-17 traccia il pattern). Resta
 * description-only — la scelta della classe da cui pescare la mossa multiclasse
 * sarà gestita dalla UI di level-up quando arriverà.
 */

const archetipoUmano: Move = {
  id: 'monaco.archetipo-umano',
  name: 'Archetipo: Umano',
  type: 'class_special',
  classId: 'monaco',
  trigger: "Quando prendi le mosse *La Via dell'Eremita* o *La Strada dell'Eremita*",
  description:
    'Puoi sempre scegliere mosse del Druido o dello Sciamano (in aggiunta alle classi consentite dalla Regola che hai scelto).',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoElfo: Move = {
  id: 'monaco.archetipo-elfo',
  name: 'Archetipo: Elfo',
  type: 'class_special',
  classId: 'monaco',
  trigger:
    'Quando usi la saggezza che hai maturato durante la tua lunga vita come leva per *parlamentare*',
  description: 'Puoi tirare+**SAG** invece che +**CAR**.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoNano: Move = {
  id: 'monaco.archetipo-nano',
  name: 'Archetipo: Nano',
  type: 'class_special',
  classId: 'monaco',
  trigger:
    'Quando rinunci a un tesoro di grande valore, a una ricca ricompensa o a un intenso piacere materiale',
  description: 'Segna 1 PE (al massimo una volta per sessione).',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoHalfling: Move = {
  id: 'monaco.archetipo-halfling',
  name: 'Archetipo: Halfling',
  type: 'class_special',
  classId: 'monaco',
  trigger: 'Quando *intraprendi un viaggio pericoloso* e agisci come quartiermastro',
  description: 'Hai sempre successo come se avessi tirato un 10+.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoMezzorco: Move = {
  id: 'monaco.archetipo-mezzorco',
  name: "Archetipo: Mezz'orco",
  type: 'class_special',
  classId: 'monaco',
  trigger: 'Quando subisci un attacco con etichetta *impatto*',
  description: "Ignori l'etichetta *impatto* su qualsiasi attacco che subisci.",
  tags: [],
  prerequisites: [],
  replaces: [],
};

export const monacoArchetypeMoves: readonly Move[] = [
  archetipoUmano,
  archetipoElfo,
  archetipoNano,
  archetipoHalfling,
  archetipoMezzorco,
] as const;
